module.exports = __webpack_public_path__ + "app/payment/payment-details-3kMb-p-7.html";